import React from "react";
import {
    CartesianGrid,
    Legend, Line, LineChart,
    ResponsiveContainer,
    Tooltip, XAxis, YAxis
} from "recharts";
import LoadingSkeleton from "../../../common/loading-skeleton/loading-skeleton";

interface MonthLeaveTrendChartProps {
    summary: any;
    year: number;
    loading: boolean;
}

const MonthAttendanceChart = ({summary, year, loading}: MonthLeaveTrendChartProps) => {
    const chartData = (summary ?? []).map((item: any) => ({
        month: item.month.substring(0, 3),
        presentDays: item.presentDays,
        absentDays: item.absentDays,
        leaveDays: item.leaveDays,
    }));

    return (
        <section>
            <div className="pn-attendance__card__header">
                <h3 className="pn-attendance__card__title">Monthly Attendance Trends </h3>
                <span className="pn-attendance__chart__subtitle">For year {year}</span>
            </div>
            <LoadingSkeleton loading={loading}>
                <ResponsiveContainer width="100%" height={240}>
                    <LineChart
                        data={chartData}
                        margin={{
                            top: 5,
                            right: 5,
                            left: 5,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="var(--pn-border)"/>
                        <XAxis
                            width={20}
                            tick={{
                                fontSize: 12,
                                fill: "var(--pn-text-primary)",
                            }}
                            dataKey="month"
                            stroke="var(--pn-text-primary)"
                        />
                        <YAxis
                            width={30}
                            domain={[0, 50]}
                            tick={{
                                fontSize: 12,
                                fill: 'var(--pn-text-secondary)'
                            }}
                            stroke="var(--pn-text-primary)"
                        />
                        <Tooltip
                            cursor={{
                                stroke: 'var(--pn-text-secondary)',
                            }}
                            contentStyle={{
                                backgroundColor: 'var(--pn-bg-card)',
                                border: '1px solid var(--pn-border)',
                                borderRadius: '8px',
                                padding: '8px',
                                fontSize: '12px',
                                color: 'var(--pn-text-primary)'
                            }}
                        />
                        <Legend
                            verticalAlign="top"
                            align="center"
                            height={36}
                        />
                        <Line
                            type="monotone"
                            dataKey="presentDays"
                            name="Present"
                            stroke="var(--success-hover)"
                            strokeWidth={2}
                            dot={{
                                fill: 'var(--success-hover)',
                            }}
                            activeDot={{r: 8, stroke: 'var(--success-text)'}}
                        />
                        <Line
                            type="monotone"
                            dataKey="absentDays"
                            name="Absent"
                            stroke="var(--danger-hover)"
                            strokeWidth={2}
                            dot={{
                                fill: 'var(--danger-hover)',
                            }}
                            activeDot={{r: 8, stroke: 'var(--danger-text)'}}
                        />
                        <Line
                            type="monotone"
                            dataKey="leaveDays"
                            name="On Leave"
                            stroke="var(--warning-hover)"
                            strokeWidth={2}
                            dot={{
                                fill: 'var(--warning-hover)',
                            }}
                            activeDot={{r: 8, stroke: 'var(--warning-text)'}}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </LoadingSkeleton>
        </section>
    );
};

export default MonthAttendanceChart;